import { FC, useMemo, useContext, autoCommand } from 'external/react'
import {styled, clsx} from 'external/material'
import {orderBy} from 'external/lodash'
import { SelectField } from 'components/common/SelectField'
import { TeacherContext } from 'teacher/context'
import { MomentOfDayId } from '.'

type StrategyDropdownProps = {
    id: number
    moment: MomentOfDayId
}

const StyledStrategyDropdown = styled('div')(strategyDropdownStyles as any)

const dailyStrategiesPrefix = 'planning-rd-daily-strategy-'

export const StrategyDropdown: FC<StrategyDropdownProps> = props => {

    const {id, moment} = props
    const { newPlan, translate, updateState, translations} = useContext(TeacherContext) as any

    const dailyPlan = useMemo(() => {
      const dailyPlans = newPlan.content.dailyPlanning
      const dailyPlan = dailyPlans[id]
      return dailyPlan
    }, [ newPlan.content.dailyPlanning, id])

    const dailyMoment = useMemo(() => (dailyPlan[moment] || false), [dailyPlan, moment]) 

    function addStrategy (strategy: any) {
      updateState({newPlan: {content: {dailyPlanning: {[id]: autoCommand({$autoArray: {$push: [strategy]}}, moment, 'strategies')}}}})
    }

    function removeStrategy (strategy: any) {
      const strategyIndex = dailyMoment.strategies.findIndex((s:any) => s.value == strategy.value)
      if (strategyIndex < 0) return
      updateState({newPlan: {content: {dailyPlanning: {[id]: {[moment]: {strategies: {$splice: [[strategyIndex,1]]}}}}}}})
    }

    const strategies = useMemo(() => {
      return orderBy(Object.keys(translations).filter(key => key.startsWith(dailyStrategiesPrefix)).map(s => {
        const value = parseInt(s.substring(dailyStrategiesPrefix.length))
        const label = translate(s)
        return {value, label}
      }), ['value'])
    }, [translations])

    function handleStrategyChange (_:any, meta:any) {
      switch(meta.action) {
        case 'select-option': 
          return addStrategy(meta.option)
        case 'remove-value':
          return removeStrategy(meta.removedValue)
      }
    }

    return (
      <StyledStrategyDropdown >
        <SelectField
            label={translate('strategy')}
            value={dailyMoment.strategies}
            isMulti
            options={strategies}
            onChange={handleStrategyChange}
        />
     </StyledStrategyDropdown>
    )
}

export {StrategyDropdown as default}

function strategyDropdownStyles() {
    return {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '30px', marginBottom: '30px',
      justifyContent: 'center'
    }
}